module.exports = __webpack_public_path__ + "static/media/dicom-pelvic.fd136912.jpg";